import { axios } from 'api'
import { useCallback } from 'react'

const useDownload = () => {
  const clickLink = useCallback((href, fileName) => {
    const link = document.createElement('a')
    link.href = href
    link.target = '_blank'
    link.setAttribute('download', fileName || 'document.pdf')
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    URL.revokeObjectURL(href)
  }, [])

  const downloadFile = useCallback(
    (item_url, name = '', handleComplete = () => {}) => {
      const fileName = name || item_url?.split('/')?.pop()
      axios
        .get(item_url, {
          responseType: 'blob'
        })
        .then((response) => {
          const href = URL.createObjectURL(response?.data)
          clickLink(href, fileName)
          handleComplete()
        })
        .catch(() => {
          clickLink(item_url, fileName)
          handleComplete()
        })
    },
    [clickLink]
  )

  return { downloadFile }
}

export default useDownload
